function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32.99 45.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-594.85,218.12l-8.53-8.56a2.22,2.22,0,0,0-3.08,0,2.2,2.2,0,0,0-.65,1.55,2.2,2.2,0,0,0,.65,1.55l8.53,8.54a4.38,4.38,0,0,0,3.09,1.29,4.38,4.38,0,0,0,3.09-1.29L-571.58,201a2.17,2.17,0,0,0,.64-1.54,2.17,2.17,0,0,0-.64-1.54,2.17,2.17,0,0,0-1.54-.64,2.17,2.17,0,0,0-1.54.64Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -618.01,
    y: 264.24,
    width: 55.37,
    height: 55.37,
    rx: 7.91,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -520.31,
    cy: 291.92,
    r: 28.2,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.22,14.68h-.08v-5a9.65,9.65,0,1,0-19.29,0v5H6.77A6.77,6.77,0,0,0,0,21.44V39a6.78,6.78,0,0,0,6.77,6.77H26.22A6.78,6.78,0,0,0,33,39V21.44A6.77,6.77,0,0,0,26.22,14.68Zm-15.37-5a5.65,5.65,0,1,1,11.29,0v5H10.85ZM29,39a2.77,2.77,0,0,1-2.77,2.77H6.77A2.77,2.77,0,0,1,4,39V21.44a2.77,2.77,0,0,1,2.77-2.76H26.22A2.77,2.77,0,0,1,29,21.44Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,26.73a3.5,3.5,0,1,0-5.5,2.87v5a2,2,0,0,0,4,0v-5A3.48,3.48,0,0,0,20,26.73Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.a25e6bf2.svg";
export { ForwardRef as ReactComponent };